// Centralised numeric date formatting with an org-wide EU/US preference.
// EU => dd/MM/yyyy (default), US => MM/dd/yyyy. The preference is a module-level
// singleton set from AuthContext when the org branding loads, so plain modules
// (PDF/PNG export scripts) format dates the same way the hub does.

let _pref = "eu";

export function setDateFormat(pref) {
  _pref = String(pref || "").toLowerCase() === "us" ? "us" : "eu";
}

export function getDateFormat() {
  return _pref;
}

function toDate(d) {
  if (d instanceof Date) return isNaN(d.getTime()) ? null : d;
  if (d == null || d === "") return null;
  const s = String(d);
  const dt = new Date(s + (s.length === 10 ? "T00:00:00" : ""));
  return isNaN(dt.getTime()) ? null : dt;
}

// Numeric date: dd/MM/yyyy (EU) or MM/dd/yyyy (US).
export function fmtDateNum(d, pref = _pref) {
  const dt = toDate(d);
  if (!dt) return d ? String(d) : "";
  const dd = String(dt.getDate()).padStart(2, "0");
  const mm = String(dt.getMonth() + 1).padStart(2, "0");
  const yyyy = dt.getFullYear();
  return pref === "us" ? `${mm}/${dd}/${yyyy}` : `${dd}/${mm}/${yyyy}`;
}

// Compact numeric date with 2-digit year and a custom separator (tight tables).
export function fmtDateShort(d, sep = ".", pref = _pref) {
  const dt = toDate(d);
  if (!dt) return d ? String(d) : "";
  const dd = String(dt.getDate()).padStart(2, "0");
  const mm = String(dt.getMonth() + 1).padStart(2, "0");
  const yy = String(dt.getFullYear()).slice(2);
  return pref === "us" ? `${mm}${sep}${dd}${sep}${yy}` : `${dd}${sep}${mm}${sep}${yy}`;
}
